import { useState } from 'react';
import { FiDownload, FiX } from 'react-icons/fi';
import { useInstallApp } from '@/hooks/useInstallApp';

const DISMISS_KEY = 'installAppBannerDismissedAt';
const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

const isSnoozed = () => {
  try {
    const at = Number(localStorage.getItem(DISMISS_KEY));
    return Boolean(at) && Date.now() - at < SNOOZE_MS;
  } catch {
    return false;
  }
};

/** Home-page card that installs the app in one tap; hidden once installed or dismissed. */
export default function InstallAppBanner() {
  const { isInstalled, handleInstall } = useInstallApp();
  const [hidden, setHidden] = useState(isSnoozed);

  if (isInstalled || hidden) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch {
      /* private mode — just hide it for this visit */
    }
    setHidden(true);
  };

  return (
    <div className="flex items-center gap-3 bg-[#0b0b0b] px-3 py-2.5 text-white">
      <img src="/favicon/web-app-manifest-192x192.png" alt="" className="size-10 shrink-0 rounded-lg" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold">Get the 9WINBET app</p>
        <p className="truncate text-xs text-white/60">Full-screen and one tap from your home screen</p>
      </div>
      <button
        type="button"
        onClick={handleInstall}
        className="flex shrink-0 items-center gap-1 rounded-md bg-[#F3C400] px-3 py-1.5 text-sm font-semibold text-black"
      >
        <FiDownload /> Install
      </button>
      <button type="button" onClick={dismiss} aria-label="Dismiss" className="shrink-0 p-1 text-white/60">
        <FiX />
      </button>
    </div>
  );
}
